export default {"src":"/_next/static/media/play.86576171.svg","height":7,"width":7,"blurWidth":0,"blurHeight":0};